import { fromJS } from 'immutable';
import { dispatch } from 'nike-re-framejs';

import i18n from '@i18n';
import PopupNg from '@/ui/PopupNg';

export const fireServerVersionChanged = db =>
    db.update(
        PopupNg.updater.open(
            'dialog/message',
            {
                titleIcon: 'sad-face',
                titleText: i18n('jsp.dialog.options.info.header'),
                bodyText: i18n('jsp.dialog.versionErrorMessage'),
                confirmText: i18n('jsp.dialog.versionErrorMessage.reset'),
                modal: true,
                onConfirm: () => window.location.reload()
            },
            1005
        )
    );

function getMetaTagContent(name) {
    const element = document.querySelector('meta[http-equiv="' + name + '"]');
    return element && element.getAttribute('content');
}

export const onServerInfo = ({ odstavka, versionNumber, profilesHash }) => db => {
    // ODSTAVKA
    if (odstavka) {
        db = db.setIn(['serverInfo', 'odstavka'], fromJS(odstavka));
    } else {
        db = db.removeIn(['serverInfo', 'odstavka']);
    }

    const clientVersionPlusHash = getMetaTagContent('version') + '_' + getMetaTagContent('profilesHash');
    const severVersionPlusHash = versionNumber + '_' + profilesHash;

    if (clientVersionPlusHash !== severVersionPlusHash) {
        dispatch(fireServerVersionChanged);
    }
    return db;
};

export const closeServerOutage = id => db => {
    if (id) {
        db = db.setIn(['serverInfo', 'odstavkaClosed', id], true);
    }
    return db;
};
